import { render, staticRenderFns } from "./ChangelogDialog.vue?vue&type=template&id=611ef0c4&lang=pug&"
import script from "./ChangelogDialog.vue?vue&type=script&lang=js&"
export * from "./ChangelogDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChangelogDialog.vue"
export default component.exports